

/// <reference path="AccountBalance.ts" />

// Generated class ClientAccountBalance_ManagedObject

class ClientAccountBalance_ManagedObject extends AccountBalance
{
}
